import React from "react";
import NoService from "./NoService";


const Contact = () => {


    return (
        <center>
        <NoService/>
        </center>
    )
}

export default Contact